import React from 'react';
import { ProductCategory } from 'types/product/product';
import useStyle from './select.style';
import { classNames } from '../../../../helpers/style/classNames';

export interface SelectProps {
  onChange: (value) => void;
  maxValue?: number;
  options?: Array<string>;
  productsOptions?: Array<ProductCategory>;
  value?: string | number;
  variant?: 'reporting' | 'form';
  initialOptionName?: string | number;
  initialOptionValue?: string | number;
  disabledInitialOption?: boolean;
}

export const Select = ({
  onChange,
  maxValue,
  options,
  value,
  variant = 'form',
  productsOptions,
  initialOptionName,
  initialOptionValue,
  disabledInitialOption
}: SelectProps) => {
  const classes = useStyle();
  let children = [];

  if (maxValue) {
    for (let count = 1; count <= maxValue; count++) {
      typeof initialOptionName === 'number' &&
        initialOptionName === count &&
        (value = count);
      children.push(
        <option value={count} key={count - 1}>
          {count}
        </option>
      );
    }
  }
  if (initialOptionName) {
    children.push(
      <option
        key={0}
        value={initialOptionValue ? initialOptionValue : initialOptionName}
        disabled={disabledInitialOption}
        selected={disabledInitialOption}
      >
        {initialOptionName}
      </option>
    );
  }
  if (options) {
    children = options.map((option, key) => {
      return (
        <option key={initialOptionName ? key + 1 : key} value={option}>
          {option}
        </option>
      );
    });
  }

  if (productsOptions) {
    children = [
      ...children,
      ...productsOptions.map((option, key) => {
        return (
          <option key={initialOptionName ? key + 1 : key} value={option.id}>
            {option.name}
          </option>
        );
      })
    ];
  }

  if (!options && !productsOptions && !maxValue) return null;

  return (
    <select
      value={value}
      className={classNames([classes.root, classes[variant]])}
      onChange={e => onChange(e.target.value)}
    >
      {children}
    </select>
  );
};
